import { Env } from "@emed-labs/virtual-lab-models";
import { PropsWithChildren, createContext, useEffect, useState, FunctionComponent, useContext } from "react";
import { useStateRef } from "../hooks/UseStateRef";
import { CDNUtils } from "../utils/CDNUtils";
import { useLogger } from "./LogProvider";

export interface EnvironmentProviderProps extends PropsWithChildren {}

export const EnvironmentContext = createContext<Env.Reader>({} as Env.Reader);
EnvironmentContext.displayName = "EnvironmentContext";

export const EnvironmentProvider: FunctionComponent<EnvironmentProviderProps> = (props) => {
	const logger = useLogger("providers.EnvironmentProvider");
	const [loading, setLoading] = useState(true);
	const [environment, setEnvironment, environmentRef] = useStateRef<Env.Options>(null); //null to start

	useEffect(() => {
		startup();
	}, []);

	const startup = async () => {
		try {
			setLoading(true);
			const env = await CDNUtils.loadFileFromCDN("/public-environment.json");
			setEnvironment(new Env.Options(env));
			setLoading(false);
			logger.debug("startup", "Loaded environment", env);
		} catch (error) {
			logger.error("startup", "Fatal. Unable to load environment", error);
			setLoading(false);
		}
	};

	return (
		<EnvironmentContext.Provider value={environment}>
			{environment && !loading && props.children}
		</EnvironmentContext.Provider>
	);
};
